const OutOfShelfMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2496_3473)"
        fill-opacity="0.1"
      />
      <g clip-path="url(#clip0_2496_3473)">
        <path
          d="M16.3101 6.5C16.7579 6.68081 17.0186 7.07298 17.3518 7.36008C14.5326 10.1207 11.7245 12.8703 8.89083 15.6451C8.65152 15.3938 8.36543 15.146 8.14754 14.8503C7.89248 14.5039 7.98055 14.0704 8.31596 13.7406C9.14936 12.9211 9.98528 12.1042 10.8204 11.2864C12.2985 9.83881 13.7779 8.39249 15.2538 6.94292C15.4422 6.75779 15.6327 6.58238 15.893 6.5H16.31H16.3101Z"
          fill="#052351"
        />
        <path
          d="M20.5566 12.4463H15.3896C15.4601 12.2746 15.5165 12.1154 15.5891 11.9637C15.9604 11.1876 16.5101 10.578 17.3287 10.2363C18.285 9.83721 19.3225 10.1149 19.9503 10.9248C20.2947 11.369 20.4765 11.8746 20.5566 12.4461V12.4463Z"
          fill="#052351"
        />
        <path
          d="M13.1012 8.2617C11.9929 9.34687 10.917 10.4003 9.82888 11.4657C9.68016 11.3173 9.5201 11.1689 9.37374 11.0083C9.25023 10.8728 9.26724 10.7301 9.41533 10.5812C9.64015 10.3554 9.87 10.1344 10.0977 9.91136C10.7762 9.24644 11.4542 8.5812 12.1333 7.9169C12.362 7.69304 12.4891 7.69644 12.7244 7.9206C12.846 8.03646 12.9736 8.14661 13.101 8.2617H13.1012Z"
          fill="#052351"
        />
        <path
          d="M22.7624 10.9052C22.9429 10.817 23.1053 10.7602 23.2408 10.6663C23.4497 10.5216 23.468 10.3691 23.3341 10.1595C23.2704 10.06 23.201 9.96401 23.1367 9.86497C22.8604 9.43917 22.8797 9.10409 23.2074 8.71084C23.2859 8.61673 23.3755 8.53157 23.4719 8.42944C23.6051 8.57107 23.7235 8.69711 23.8529 8.83472C23.7755 8.91988 23.7001 8.99995 23.6281 9.0828C23.4978 9.2326 23.4782 9.38672 23.6022 9.55395C23.6947 9.67876 23.7836 9.80742 23.8608 9.94164C24.0772 10.3182 24.0413 10.6413 23.7468 10.9629C23.5107 11.2207 23.2128 11.3636 22.8496 11.4088C22.8178 11.2258 22.7885 11.0574 22.7622 10.9056L22.7624 10.9052Z"
          fill="#052351"
        />
        <path
          d="M21.4948 7.58009C21.4423 7.71184 21.3941 7.83094 21.3477 7.9505C21.2902 8.09861 21.3401 8.21663 21.4598 8.31166C21.5775 8.40515 21.7004 8.49262 21.8157 8.58858C22.187 8.8976 22.2642 9.27325 22.0451 9.70029C21.8984 9.98616 21.6678 10.1867 21.3678 10.3391C21.2799 10.1748 21.1988 10.0227 21.1184 9.87261C21.2369 9.76878 21.3607 9.68131 21.4575 9.57116C21.6558 9.34484 21.6319 9.16033 21.3982 8.97334C21.3152 8.90685 21.229 8.84375 21.1459 8.77742C20.7539 8.46516 20.6616 8.13934 20.8396 7.67574C20.8856 7.55602 20.9483 7.44232 21.0104 7.31104C21.1835 7.40715 21.3398 7.49385 21.495 7.58009H21.4948Z"
          fill="#052351"
        />
        <path
          d="M18.5144 8.62085C18.7213 8.74751 18.884 8.89638 19.0748 8.94992C19.2654 9.00345 19.4839 8.96164 19.7243 8.96164C19.5121 9.1858 19.3144 9.40364 19.1055 9.61052C19.0324 9.68288 18.7295 9.563 18.7052 9.4598C18.6419 9.19105 18.5825 8.92122 18.5144 8.62085Z"
          fill="#052351"
        />
        <path
          d="M22.2779 13.0003C19.0365 12.9998 15.7952 12.9992 12.5538 13.004C12.4778 13.004 12.3844 13.0478 12.3288 13.1009C11.9304 13.4806 11.5433 13.8718 11.1439 14.2504C11.0473 14.3419 11.038 14.4289 11.0566 14.5469C11.1812 15.3402 11.3003 16.1344 11.4207 16.9285C11.5929 18.0645 11.7649 19.2005 11.9367 20.3367C12.1065 21.4606 12.2755 22.5846 12.4454 23.7085C12.5355 24.3052 12.6267 24.902 12.7178 25.4999H20.5454C21.1753 21.3344 21.8039 17.1778 22.4339 13.0114C22.3645 13.0063 22.3214 13.0003 22.2782 13.0003H22.2779Z"
          fill="#052351"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2496_3473"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
        <clipPath id="clip0_2496_3473">
          <rect width="16" height="19" fill="white" transform="translate(8 6.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default OutOfShelfMenu
